export default __webpack_public_path__ + "df447e79ffdf81baca6247e8a20ab7b3.webp";